module.exports = __webpack_public_path__ + "img/small-2.6bbf962a.jpg";